
import { Component, Prop, Watch } from "vue-property-decorator";
// import { customModal, comRegion, comInstitution } from "@newuview/ui";
import textEditor from "./text-editor.vue";
import customModal from "./Modal.vue";
import comRegion from "./comRegion.vue";
import comInstitution from "./comInstitution.vue";
import uploadFile from "./uploadFile.vue";
import ImageMark from "./ImageMark.vue";
import JsonEdit from "./JsonEdit.vue";
import { BaseVue } from "@newview/base-web";
import javaUploadFile from "./javaUploadFile.vue";
import javaUploadFileLocal from "./javaUploadFileLocal.vue";
import javaUploadFileList from "./javaUploadFileList.vue";
import autocompleteInput from "./AutocompleteInput.vue";
import { FilterHelper } from "@newview/tools";
import { AutoCompleteItemApi, AutoItemDataApi } from "@newview/smartsite-api";
@Component({
  name: "comForm",
  components: {
    // vxeGrid,
    // vxeCell,
    textEditor,
    uploadFile,
    JsonEdit,
    ImageMark,
    customModal,
    comRegion,
    comInstitution,
    javaUploadFile,
    javaUploadFileLocal,
    javaUploadFileList,
    autocompleteInput,
  },
})
export default class comForm extends BaseVue {
  autoCompleteItemApi: AutoCompleteItemApi = new AutoCompleteItemApi();
  autoItemDataApi: AutoItemDataApi = new AutoItemDataApi();
  // private defaultDateGrid?: DataGridApi;
  @Prop({ default: () => [] }) formItemData!: any; //表单项列表
  @Prop({ default: () => ({}) }) formModel!: any; //表单项绑定对象
  @Prop({ default: () => false }) onlyView!: Boolean; //表单是否只显示不编辑，默认为编辑状态
  @Prop({ default: () => [] }) options!: any; //下拉列表列表数据
  @Prop({ default: () => false }) labelInValue!: Boolean;
  mounted() {
    this.showSign();
  }
  instanceListDatas: any = [];
  InstanceColumns: any = [
    { colType: "ch", IsAll: true, width: 30 },
    { key: "", colType: "seq" },
    { key: "DataValue", title: "填报内容", align: "left" },
  ];
  ossClient: any;
  srcitem: any = "";
  nvImgstart: any = 0;
  baseData: any = "";
  imgBase: any = "";
  isShowReport = false;
  showAutoComplete = false;
  signModel: any = {};
  autoItemData: any = [];
  signPicDef: any =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAeCAYAAADnydqVAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAADJmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTg4OTlBQTc4NTUyMTFFQjg4QThEMTFDN0NFNzE4MTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTg4OTlBQTg4NTUyMTFFQjg4QThEMTFDN0NFNzE4MTUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5ODg5OUFBNTg1NTIxMUVCODhBOEQxMUM3Q0U3MTgxNSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5ODg5OUFBNjg1NTIxMUVCODhBOEQxMUM3Q0U3MTgxNSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmuCzwMAAAciSURBVGhD7VnrUlNXGF0kXHLnIhIIVw0Sqlxsaall2g52Rmf6x5k+Wx+gT9CZ1umP1l6gVbHKMGMEKyAZqkJCRgHNhXCn69vnBHIkkQAh1EwWkwnZ55xNZq+91rf2R8kOgSIKFib9vYgCRZHgAkeR4AKHoQZvbG6ipKRE/3Q8yLQmkwlmvoo4PRgI/va7n1DpssOUA5Jj8QQ+77+ELl+LPlLEaaCgU3Q0vIQYrHC4rXDqY0dHAtEY4HRY9c/ZIoFQYB5BPgtHDfq8NdpwnlAY/hmewfDIhHpNy0IqyMIGMcXF3R3KCtpz04ElRPURxJYwNjKOoZFAyvxZQJ67NY5RzjUfP8rmOD4KguBobBWR2AoiqEGDQ0aotvAyVcMxLvLorQe46V9S974bCUz7AyRkDpNJksNBkjuDeZ3YYCrx74RsCj4nv1K5nV4bCV82bpw8wGDRQVpaWalZ/3Q8bG1vw+WwwWat0EdOCqK4ZUQd1eigFUcDExgKrOjXBDY09nrRx2sHIeR/gNGw/kGBz3o96PBaERPiw5zX3Y4bvQfZLDcKFT+ZQe0ubzcGOWc+YCD4x1/uw26z5CRJJ1bX0dXZgramOn0kP4hSsTFu1CkqJaKPCQ5a1GhgBmPhVTi92maIxhJUntRuUfUyUG9Bg7smq1qeuslc7ib4uEkc8RkMKRexoXOgCx3KaU4eBoJFdTk7JvGnZKdES+S5mTI9SESIiV0gYSrmZ81LUaGLivPVa7877CQo3cLGghh+tERyu0iuNhRlXR+TTRITB9gbzwZvbxY1/8ic2nCNvf2Hmuu4yFuKfrUcgbnEhKpKe0420R4B+oCujAbWvhAVLLVyV8EsFS6+Od1c8DQqllAldbGBSlMK5dx7NZsEU7kdvfq1LKG+H+c4jIucBAwEz/wbRFlZWVrBbW5tobbKBQdty2Q6HEGLy1GMPZrB6to6PuryoslTq185KsQ250kKgwv0ehtfpa0yVJHMRreFKtIXlwFHEcTjSVYEJdVG5V/1auRPSu0VolnLpc5nNw+/Y4B1WHeT0yBXYCB4+O44rNbytApbW9uAt60BdbVVKC3NPnwvvFyG//EsXi5GUF9Xje4PWuHmHLlA0go9VB6YpJ1uj0rRezVQlCvpOtsFluQbBOwe9DFIqTosm4mbM5miBcm6qiX2DEixZfU9DPda4Otpf/fzOYKB4ERiTbUXZchsNmF7ewfl5aWK8K2t7d3xbC12fmER/olZLL6JwtvagK6OFrhcorocYNdGZfEsrHc1rG2SbjWSojGOkaQ+flb3HZh+dVcQJ5BNsS8Bi4L5PJ1BO+Zw7oH0tp3OnjWkOE5Wafz4yFiDxZLNZjPT6BziK2s411yHKmljZtFblubCKlP0PM+iUnt95z24RHIddot+R26gzqh+UUlKMk1Vjpw/GWhUPXY04WoGQjRyAwjGLXQDWjndYCqszdtIV/BwXodd1E97PkB1+45p6gzMORnwRLHJo1i+LDstWxFa072xady5/0TiMCqdNkw8eaaIPghPZ4N48vQFHk+/QIQy6Pa10Jbbck6uwMlaqxHG93QLzyPTZLIW8++nJVfvUk2GaZsDtE0qXja1kCvBTMrA1II0O8Yx9EgLY5kQ8uvk6qFO4HI3sm6TXG6iEMlXCZ+bzZeneryP4I3NDdy+N4H2tnq0NJ5Rddd9thLmLBogQqz/n1la+zbDmgmXeA6+6GuGzVKu35FjMC1Lp8jlbeQCvgWxwOv9uzboytAmlMQdpd12KnLJt3TF1BWxYB6PepvglDajl6ErowNIGJvAFB2gs7cbN/jcoP53IwxaN6WTxg0yqitbmif7vu8JYZ9Ff3/zLgY+7SSp1bt2/DvDV9eFZpytdWFugYsafIWLHc3qP09JzD5bwOjDGWzQ2q/0+VDNaxYSe/KdrLdBux2h3dIS+5iCx5Rd1+CT6xqB2SBE1QZJdJTp2VBHD1s36Q4h1vRke1NsWgJhPsJVEgaCp1k7F9/E8XGP19Cy/OHnvzH4WTdmXyygoqIMr3lPU0MtGpiKy8pK1T1/UvUCH9VUe8aFUtbv0wdtMZzI3OBIC9kge21GabeKvXvq9+ro+wSDRccT63A6pVWpD+hgblbvs8/DWOdxqabKSSvfUp0vgaTtqOom7SjF/j/IFVi19uKhSLGiY4DWLvbO16Cy23atjr5n5AoMBM8wIHW0evYRtLK2juF74+i5eI41tRUhHn8keFkqyvGGat4k2V8N9KD/Q9+JhKkijg4DwSs82kgP2YgdfPP1FVz7ohfnW9wopyXHeF6WY9Rvfz3ExPRz/Hr7IV5H4rCy5mZzjCoifzCwsb6+gf2n4hJUlJfBznNgkjy55Y87frTxbNx/+QKufXkZ9Wdz050qIrfI2Og4CJusv2YW61z996mIk8GRCS7i/UCxYBY4igQXOIoEFzSA/wA0GzvA9p2r3QAAAABJRU5ErkJggg==";
  javaEditContent = ""; // java富文本字符串
  @Watch("formModel")
  showformModelChange() {
    this.showSign();
  }
  getSelectText(value, list) {
    return FilterHelper.sysDicFilter(value, list);
  }

  getFormatDate(date, format = "yyyy-MM-dd") {
    if (!date) return "";
    let dateObj = new Date(date);
    if (format.indexOf("HH") > -1) {
      format = "yyyy-MM-dd hh:mm"
    }
    return this.ForMatDate(dateObj, format);
  }

  getDaterange(values: string[]) {
    if (
      this.isNull(values) ||
      Object.prototype.toString.call(values) !== "[object Array]"
      || this.isNull(values[0])
    )
      return "";


    return values.map((e) => e.substring(0, 10)).join("~");
  }

  signSuccess(item, { result, type, index }) {
    if (this.formModel[item.model]) {
      let signresult = this.formModel[item.model];
      signresult["sealResult" + type] = result;
      this.$set(this.formModel, item.model, signresult);
    }
    this.$set(item.signParam, "isSign" + type, false);
    item.signSuccess({ result, type, index });
  }
  async showSign(index = 0) {
    if (this.formItemData.length == 0) {
      return;
    }
    let item = this.formItemData[index];
    if (item.type === "signCA") {
      // let signImg = await this.getSignPic(this.formModel[item.model])
      // this.$set(this.signModel, `${item.model}_SignPic`, signImg);
    }
    index++;
    if (index < this.formItemData.length) {
      this.showSign(index);
    }
  }

  OnFocusEvent(item) {
    if (item.OnFocusEvent) {
      item.OnFocusEvent();
    }
  }
  onChange(event, item) {
    this.$emit("eventid", event);
    this.$emit("change", {
      event: event,
      item: item,
      data: this.formModel,
    });
    if (item.onChange) {
      item.onChange(event, item);
    }
  }
  onCreate(val, item) {
    item.children.push({
      value: val,
      text: val,
    });
  }

  onClear(event, item) {
    this.$emit("change", {
      event: event,
      item: item,
      data: this.formModel,
    });
    if (item.onChange) {
      item.onChange(event, item);
    }
  }

  DatePickerOnchange(value1, modelKey) {
    this.$set(this.formModel, modelKey, value1);
  }
  MonthPickerOnchange(value1, modelKey) {
    this.$set(this.formModel, modelKey, value1);
  }
  RangeDatePickerOnchange(value2, modelKey) {
    this.$set(this.formModel, modelKey, value2);
    this.$set(this.formModel, modelKey[0], value2[0]);
    this.$set(this.formModel, modelKey[1], value2[1]);
  }
  TimePickerOnchange(value1, modelKey) {
    this.$set(this.formModel, modelKey, value1);
  }
  jsonDataChange(value, modelKey) {
    this.$set(this.formModel, modelKey, value);
  }
  jsonDataChangeCustom(value) {
    this.$emit("jsonData", value);
  }
  fileUrl(value){
    this.$emit("fileUrl",value)
  }
  scanSuccess1(value){
    this.$emit("scanSuccess1",value)
  }
  // 级联菜单值发生改变
  CascaderChange(item, value) {
    if (item.onChange) {
      item.onChange(value);
    }
    this.$set(this.formModel, item.model, value);
  }

  formItemOnchange(event, item) {
    if (item.type == "number") {
      this.$set(this.formModel, item.model, event);
    }

    this.onChange(event, item);
  }

  onBlurEvent(event, item) {
    if (item.blurEvent) {
      item.blurEvent(event, item);
    }
  }
  //图片改变后执行s
  dataurl(item, data) {
    this.formModel[item.model] = data;
    this.srcitem = data.url;
    this.isShowReport = false;
  }
  closecode() {
    this.isShowReport = false;
  }
  @Watch("isShowReport")
  showImageChange(newVal: any) {
    if (newVal == true) {
      this.nvImgstart = 1;
    } else {
      this.nvImgstart = 0;
    }
  }

  signDbClick(event, item) {
    let that = this;
    if (item.dbClickEvent) {
      item.dbClickEvent(event).then((data) => {
        that.$set(that.signModel, `${item.model}_SignPic`, data);
        // that.$set(that.formModel, item.model, that.$globalData.localUser.Id);
      });
    }
  }
  changeSwitch(event, item) {
    this.$emit("on-change", event);
    if (item.onchange) item.onchange(event, item);
  }
  writeText() {
    this.ref("form_textEditor").forEach((item) => {
      item.writeText();
    });
  }
  checkContent(token) {
    //通过token校验富文本内容 msh 20210710
    let checked: boolean = true;
    this.ref("form_textEditor").forEach((item) => {
      if (item.Token == token) {
        checked = item.checkedTextIsEmpty();
        return;
      }
    });
    return checked;
  }

  // 通过tag获取行政区域组件显示文本
  getComRegionText(tag = "") {
    if (tag == "") {
      return this.ref("comRegion")[0].selectedValueText;
    }
    let RegionObj: any = {};
    this.ref("comRegion").forEach((item) => {
      if (tag == item.tag) {
        RegionObj = item;
      }
    });
    return RegionObj.selectedValueText;
  }
  /**
   * .net附件验证
   * @param {*} groupName 分组名称 可不传，默认验证所有分组
   * @param {*} Token Token 可不传，默认为验证表单中所有附件组件（在一个表单中存在多个附件组件时传递）
   * @return {*} 附件数量
   */
  validateUploadFiles(groupName = "默认", Token = "") {
    if (Token == "") {
      return this.ref("form_uploadFile")[0].getUploadFilesCount(groupName);
    }
    let uploadObj: any = {};
    this.ref("form_uploadFile").forEach((item) => {
      if (Token == item.Token) {
        uploadObj = item;
      }
    });
    return uploadObj.getUploadFilesCount(groupName);
  }
  /**清除签字 */
  ClearCASignView() {
    this.ref("form_vasignview").forEach((item) => {
      item.clearSeal();
    });
  }
  /**
   * @param {*} groupName 分组名称 可不传，默认验证所有分组
   * @param {*} Token Token 可不传，默认为验证表单中所有附件组件（在一个表单中存在多个附件组件时传递）
   * @return {*} 附件数量
   */
  javaValidateUploadFiles(groupName = "默认", Token = "") {
    if (Token == "") {
      return this.ref("javaUploadFile")[0].getUploadFilesCount(groupName);
    }
    let uploadObj: any = {};
    this.ref("javaUploadFile").forEach((item) => {
      if (Token == item.Token) {
        uploadObj = item;
      }
    });
    return uploadObj.getUploadFilesCount(groupName);
  }

  /**
   * @param {*} groupName 分组名称 可不传，默认验证所有分组
   * @param {*} Token Token 可不传，默认为验证表单中所有附件组件（在一个表单中存在多个附件组件时传递）
   * @return {*} 附件数量
   */
  javaValidateUploadFileList(groupName = "默认", Token = "") {
    if (Token == "") {
      return this.ref("javaUploadFileList")[0].getUploadFilesCount(groupName);
    }
    let uploadObj: any = {};
    this.ref("javaUploadFileList").forEach((item) => {
      if (Token == item.Token) {
        uploadObj = item;
      }
    });
    return uploadObj.getUploadFilesCount(groupName);
  }

  javaEdit(data, event) {
    this.$emit("javaEditcontent", data);
    let param: any = {};
    param.value = data;
    param.key = event;
    let list: any = [];
    list.push(param);
    for (const iterator of list) {
      if (iterator.key == event) {
        this.$emit("textEdit", list);
      }
    }
  }
  iconBtnRow: any = {};
  async tipsClick(item) {
    this.iconBtnRow = item;
    //1、datakey查询Id
    let data: any = await this.autoCompleteItemApi.getEntities(
      this.getQueryWrapper().eq("ItemKey", item.dataKey)
    );
    if (data.code == 200 && data.data.length > 0) {
      let Id = data.data[0].Id;
      let result = await this.autoItemDataApi.getEntities(
        this.getQueryWrapper().eq("ItemId", Id)
      );
      if (result.code == 200) {
        this.instanceListDatas = result.data;
      }
    }
    this.showAutoComplete = true;
  }
  saveUnit() {
    let data: any = (this as any).$refs.InstanceList.getCheckedRowData();
    this.$emit("iconBtnData", this.iconBtnRow.model, data);
    this.showAutoComplete = false;
  }
  AddTags(item: any) {
    this.prompt("标签名称", "添加标签名", (content) => {
      this.formModel[item.model].push(content);
    });
  }
  RemoveTags(spina: string, item: any) {
    this.formModel[item.model] = this.Baselinq.from(this.formModel[item.model])
      .where((f) => f.toString() != spina)
      .toArray();
  }
  imgUrlClick(imgurl) {
    this.$emit("imgUrlChange", imgurl);
  }
  doFileChangeValue($event, item) {
    this.formModel[item.model] = $event;
  }
}
